import SrBigUpload from "./SrBigUpload.vue";

SrBigUpload.install = function(Vue) {
  Vue.component(SrBigUpload.name, SrBigUpload);
};

export default SrBigUpload;


// WEBPACK FOOTER //
// ./packages/SrBigUpload/index.js